import { useEffect, useState } from 'react'

import { config } from '@/config'

type CustomDesign = Record<string, any>

export const useCustomDesign = ({
  type,
  artistId,
}: {
  type: 'ArtistTop' | 'ArtistStore'
  artistId?: string
}) => {
  const [customDesign, setCustomDesign] = useState<CustomDesign | null>(null)

  const { path, localStorageKey } = (() => {
    switch (type) {
      case 'ArtistTop':
        return {
          path: `${config.appStorageUrl}customDesign/artists/${artistId}/ArtistTop.json`,
          localStorageKey: `CUSTOM_DESIGN_ARTIST_TOP_${artistId}`,
        }
      case 'ArtistStore':
        return {
          path: `${config.appStorageUrl}customDesign/artists/${artistId}/ArtistStore.json`,
          localStorageKey: `CUSTOM_DESIGN_ARTIST_STORE_${artistId}`,
        }
      default:
        throw new Error(`Unknown custom design type: ${type}`)
    }
  })()

  useEffect(() => {
    const loadDesign = async () => {
      const cached = localStorage.getItem(localStorageKey)
      if (cached) {
        setCustomDesign(JSON.parse(cached))
      }

      try {
        const res = await fetch(path)
        const json = await res.json()
        localStorage.setItem(localStorageKey, JSON.stringify(json))
        setCustomDesign(json)
      } catch (err) {
        // ２回目以降nullを返さないようにして、未設定の場合もloadingのラグを無くす
        setCustomDesign({})
        localStorage.setItem(localStorageKey, JSON.stringify({}))
      }
    }

    loadDesign()
  }, [path, localStorageKey])

  return { customDesign }
}
